/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_AligningInputs */



/**
* | output |
* | --- |
* | "Aligning events…" |
*
* @param {Compare_Event_Groups_AligningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_aligning = /** @type {((inputs?: Compare_Event_Groups_AligningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_AligningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Alignement des événements…")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse aufeinander abstimmen…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allineamento degli eventi…")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Согласование событий…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alineando eventos…")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件协调……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの調整…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटनाओं का संरेखण…")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alinhando eventos…")
	return /** @type {LocalizedString} */ ("Aligning events…")
});